module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-left-quote-dc17f0a5.svg";